export class DateFilterModel {
  startDate: Date | string = ''
  endDate: Date | string = ''
  filter?: FilterPeriodType = FilterPeriodType.day
  // isDate?: boolean
}

export enum FilterPeriodType {
  day = 'day',
  week = 'week',
  month = 'month',
}
